<div class="nsc-card-title-error">
    <h2 class="mat-title nsc-margin-bottom">
        <div class="row nsc-row--12">
            <div class="col-auto">
              <mat-icon>{{icon}}</mat-icon>
            </div>
            <div class="col">{{title}}</div>
          </div>
        </h2>
  </div>
  